var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('LikeButtonView',{attrs:{"size":_vm.size,"like-count":_vm.likeCount,"is-liked":_vm.isLiked},on:{"click":_vm.handleLikeClick}}):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }